import { css } from 'styled-components';

import {
  fontSize as fontSizeRegular,
  fontSizeSmall,
  fontSizeXSmall,
  fontSizeLarge,
  styleAttribute,
} from '@fil-react-mixins/styled';

export default css`
  ${({ fontSize }: any) => {
    /* istanbul ignore else */
    if (fontSize) {
      switch (fontSize) {
        case 'small':
          return fontSizeSmall;
        case 'xsmall':
          return fontSizeXSmall;
        case 'regular':
          return fontSizeRegular;
        case 'large':
          return fontSizeLarge;
        default:
          return styleAttribute('font-size', fontSize);
      }
    }
    return '';
  }}
`;
